.Body {
    --fg: var(--black);
    --bg: var(--white);

    font-family: 'Clash Display', sans-serif;
    font-variation-settings: "wght" 500;
    margin: 0;
    width: 100vw;
    background: var(--bg);
    color: var(--fg);
    font-size: var(--text-size);
    overflow-x: hidden;
    opacity: 0;
}

.Wrapper {
}

.Black {
    --fg: var(--white);
    --bg: var(--black);
}

.LilacDream {
    --fg: var(--white);
    --bg: var(--lilac-dream);
}

.IsFixed .Main {
    height: 600vh;
}

.Content {
    position: relative;
    top: 0;
    width: 100%;
    display: grid;
    grid-template-rows: minmax(0, 1fr) minmax(0, max-content);
    grid-template-columns: minmax(0, 1fr);
    min-height: 100vh;
}

.IsFixed .Content {
    position: fixed;
    width: 100vw;
    height: 100vh;
}

.Container {
    position: absolute;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    will-change: transform;
}